import React, { useContext } from "react";
import { MAX_DRAWER_EXTENSION_SCREEN } from "common/constants";
import Flex from "common/Boxes/Flex";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import OrdersSection from "features/trades/TradeDrawer/Orders/OrdersSection";
import AddAmountModal from "features/trades/EditTrade/AddAmountModal";
import EditTradeContext from "@shared/features/trades/EditTrade/EditTrade.context";
import { OrdersWrapper } from "features/trades/TradeDrawer/Orders/styles";
import { OrderTypes } from "@shared/features/trades/common/types";
import useMedia from "utils/hooks/useMedia";
import TradeChart from "features/trades/TradeDrawer/TradeChart";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import { TradeDetailsContext } from "@shared/features/trades/TradeDetails.context.tsx";

const OrdersPage = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADES);
  const {
    getTradeExtraInfoOrdersStatus,
    getTradeExtraInfoStatsStatus,
    getTradeExtraInfoActivitiesStatus,
  } = useContext(TradeDetailsContext)!;
  const {
    updateOrdersWithAddedAmount,
    updateOrdersWithAddedQuantity,
    setAddQuantityModalOpen,
    setAddAmountModalOpen,
    addAmountModalOpen,
    addQuantityModalOpen,
    entryOrders,
    takeProfitOrders,
    stopOrders,
    amountData,
    quantityData,
    isEdit,
    amountsDataLoading,
    editTradeLoading,
  } = useContext(EditTradeContext) || {};
  const isSmallScreen = useMedia(
    [`(max-width: ${MAX_DRAWER_EXTENSION_SCREEN})`],
    [true],
    false
  );
  const loading =
    getTradeExtraInfoOrdersStatus.isLoading ||
    getTradeExtraInfoStatsStatus.isLoading ||
    getTradeExtraInfoActivitiesStatus.isLoading ||
    amountsDataLoading ||
    editTradeLoading;

  return (
    <LoadingSpinnerOverlay
      isLoading={loading}
      wrap={true}
      spinnerStyle={{ position: "sticky", top: 100 }}
      hideContentWhileLoading={true}
      spinnerSize="large"
    >
      <Flex $flexDirection="column" $alignItems="center">
        {isSmallScreen && <TradeChart />}
        <OrdersWrapper>
          <OrdersSection
            orders={entryOrders}
            title={t("orders.entry_orders")}
            isEdit={isEdit}
            orderType={OrderTypes.ENTRY}
          />
          <OrdersSection
            orders={takeProfitOrders}
            title={t("orders.take_profit_orders")}
            hideAmounts={true}
            isEdit={isEdit}
            orderType={OrderTypes.TAKE_PROFIT}
          />
          <OrdersSection
            orders={stopOrders}
            title={t("orders.stop_orders")}
            hideAmounts={true}
            isEdit={isEdit}
            orderType={OrderTypes.STOP}
          />
        </OrdersWrapper>
      </Flex>
      {addAmountModalOpen && amountData && (
        <AddAmountModal
          closeModal={() => setAddAmountModalOpen?.(false)}
          amountData={amountData}
          onSave={updateOrdersWithAddedAmount}
          validateMinAmount={false}
        />
      )}
      {addQuantityModalOpen && quantityData && (
        <AddAmountModal
          closeModal={() => setAddQuantityModalOpen?.(false)}
          amountData={quantityData}
          onSave={updateOrdersWithAddedQuantity}
          validateMinAmount={true}
        />
      )}
    </LoadingSpinnerOverlay>
  );
};

export default OrdersPage;
